import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import NoItemResult from '../../../../components/results/NoItemResult';
import { type PermissionValues } from '../../../../utilities/hasPermissions';

export type PromoCodeModuleEmptyListProps = {
    permissions: Pick<PermissionValues, 'hasCreatePermission'>;
};

const PromoCodeModuleEmptyList = ({ permissions }: PromoCodeModuleEmptyListProps) => {
    const { t } = useTranslation(['promoCodeModuleDetails']);
    const navigate = useNavigate();
    const { hasCreatePermission } = permissions;

    return (
        <NoItemResult
            extra={
                hasCreatePermission && (
                    <Button onClick={() => navigate('/admin/promoCodes/add')} type="primary">
                        {t('promoCodeModuleDetails:emptyList.noData.action')}
                    </Button>
                )
            }
            subTitle={t('promoCodeModuleDetails:emptyList.noData.message')}
        />
    );
};

export default PromoCodeModuleEmptyList;
